// extracted by mini-css-extract-plugin
export default {"closeButton":"PopUpInappropriate_closeButton__Wte3T","rounded":"PopUpInappropriate_rounded__APWEQ"};